import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";

export default function StyleFeature(feature:Feature<Geometry>) {
  return [
	new Style({
	  stroke: new Stroke({
		color: "#ff0000",
		width: 3,
		lineDash: [5,5]
	  }),
	  fill: new Fill({
		color: "rgba(255,0,0,0.1)",
	  }),
	  image: new CircleStyle({
		radius: 5,
		fill: new Fill({
		  color: "#007280",
		}),
		stroke: new Stroke({
		  color: "#007280",
		  width: 1,
		}),
	  }),
	  text: new Text({
		font: 'bold 14px "Helvetica Neue", "Arial", san-serif',
		textBaseline: "middle",
		backgroundFill: new Fill({
		  color: "#535353",
		}),
		fill: new Fill({
		  color: "white",
		}),
	  }),
	}),
  ];
}